import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class ComunicationDashboard {
public enterId = new Subject<number>();
public receivedId = this.enterId.asObservable();
}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers/comunication-dashboard.ts